import { createAction } from '@ngrx/store';

export const StartOverFlow = createAction('[Start Over] Start Over Flow');
export const StartOverStateCleared = createAction('[Start Over] State Cleared');
